import { Box, Checkbox, FormControlLabel, Radio } from '@mui/material';

const LAYOUTS = {
  stack: { display: 'flex', flexDirection: 'column', rowGap: 0.25 },
  inline: { display: 'flex', flexWrap: 'wrap', columnGap: 3.5, rowGap: 0.25 },
  columns: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
    columnGap: 2.5,
    rowGap: 0.25,
  },
};

/**
 * The wireframes' checkbox/radio groups: checkboxes for multi-select (`multiple`, value
 * is an array), radios for single-select (value is a scalar, e.g. true/false).
 * `layout`: "stack" (one per line), "inline" (Yes/No), or "columns" (3-up grid).
 */
export default function ChoiceGroup({ options, value, onChange, multiple = false, layout = 'stack', disabled = false }) {
  const isChecked = (optionValue) => (multiple ? value.includes(optionValue) : value === optionValue);

  const handleToggle = (optionValue) => {
    if (!multiple) {
      onChange(optionValue);
    } else if (value.includes(optionValue)) {
      onChange(value.filter((v) => v !== optionValue));
    } else {
      onChange([...value, optionValue]);
    }
  };

  const Control = multiple ? Checkbox : Radio;

  return (
    <Box role={multiple ? 'group' : 'radiogroup'} sx={LAYOUTS[layout]}>
      {options.map((option) => (
        <FormControlLabel
          key={String(option.value)}
          disabled={disabled}
          control={
            <Control
              size="small"
              checked={isChecked(option.value)}
              onChange={() => handleToggle(option.value)}
            />
          }
          label={option.label}
          sx={{
            alignItems: 'flex-start',
            mr: 0,
            '& .MuiFormControlLabel-label': { fontSize: '0.875rem', lineHeight: 1.45, pt: '9px' },
          }}
        />
      ))}
    </Box>
  );
}
